module.exports = __webpack_public_path__ + "static/media/edit-readiness.670292d5.svg";